import { render } from "./CIS-Content-Card.vue?vue&type=template&id=6ffb9270&scoped=true"
import script from "./CIS-Content-Card.vue?vue&type=script&lang=js"
export * from "./CIS-Content-Card.vue?vue&type=script&lang=js"

import "./CIS-Content-Card.vue?vue&type=style&index=0&id=6ffb9270&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ffb9270"]])

export default __exports__